// Spend rows paid together (one Add Spend, one bill settlement) share a referenceId;
// the Spend tab, the invoice and the player's wallet all show that number for them
const SPEND_TYPES = ["table-charge", "food-drink", "membership", "event-entry"];

// IDs created before they became digits only carry a type prefix (DEP, TBL, STL...)
export const stripIdPrefix = (id) => String(id ?? "").replace(/^[A-Za-z]+-?(?=\d)/, "");

// The number shown for a wallet transaction, the same on every screen
export const displayTransactionId = (txn) => {
  const id =
    SPEND_TYPES.includes(txn?.transactionType) && txn?.referenceId
      ? txn.referenceId
      : txn?.transactionId;
  return stripIdPrefix(id);
};
